import request from '../request'

// 获取党费列表
export function getPartyFeeList(params) {
  return request({
    url: '/app/dangfei/list',
    method: 'get',
    params,
  })
}

// 获取党费详情
export function getPartyFeeDetail(id) {
  return request({
    url: `/app/dangfei/detail/${id}`,
    method: 'get',
  })
}

// 提交党费缴纳
export function submitPartyFee(data) {
  return request({
    url: '/app/dangfei/submit',
    method: 'post',
    data,
  })
}
